import React, { useEffect, useRef, useState } from "react";
import { LayoutHome } from "./LayoutHome";
import {
  Button,
  Card,
  notification,
  Popconfirm,
  Table,
  Input,
  Space,
} from "antd";
import { FaSave } from "react-icons/fa";
import { SelectPicker, Text } from "rsuite";
import { getListaPacientes } from "./Services/ConsultasServices";
import {
  getAsignacion,
  getFiltrosXInventario,
  saveAsignaModalidadUso,
  getListaPacientesFiltro,
  saveAsignaFiltro,
} from "./Services/FiltrosServices";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import moment from "moment/moment";

export const AsignaFiltro = () => {
  const [idNegocio] = useState(JSON.parse(sessionStorage.getItem("auth")).id);
  const idUser = JSON.parse(sessionStorage.getItem("auth")).idUser;
  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);
  const [idPac, setIdPac] = useState(0);
  const [modalidad, setModalidad] = useState("");
  const [listPacientes, setListPacientes] = useState([]);
  const [listInvent, setListInvent] = useState([]);
  const [estatus, setEstatus] = useState("");
  const [idEntrada, setIdEntrada] = useState(null);
  const [dataPacientesFiltro, setDataPacientesFiltro] = useState([]);
  const [listModalidad, setListModalidad] = useState([
    { label: "NR - No Reuso", value: "NR - No Reuso" },
    { label: "RU - Reuso", value: "RU - Reuso" },
  ]);

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Última Fecha",
      dataIndex: "ultimaFecha",
      width: "8%",
      key: "ultimaFecha",
      align: "center",
      render: (text) => moment(text).format("DD/MM/YYYY"),
    },
    {
      title: "Paciente",
      dataIndex: "nomPaciente",
      width: "40%",
      key: "nomPaciente",
      sorter: (a, b) => a.nomPaciente.length - b.nomPaciente.length,
      ...getColumnSearchProps("nomPaciente"),
    },
    {
      title: "Filtro",
      dataIndex: "filtro",
      width: "50%",
      key: "filtro",
      sorter: (a, b) => a.filtro.length - b.filtro.length,
    },
  ];

  const loadPacientes = async () => {
    await getListaPacientes(idNegocio)
      .then(async (res) => {
        setListPacientes(res);
        await getListaPacientesFiltro(idNegocio).then((res) => {
          setDataPacientesFiltro(res);
        });
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Inicio de sesión inválido",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction("Error", error.message);
        }
      });
  };

  const getAsignaModalidad = async (idPac) => {
    setIdPac(idPac);

    await getAsignacion(idNegocio, idPac)
      .then(async (res) => {
        setEstatus(res.estatus);
        setModalidad(res.tipoModal);
        await getFiltrosXInventario(idNegocio).then((res) => {
          setListInvent(res);
        });
      })
      .catch((err) => {
        errorNotificaction("Error", err.message);
      });
  };

  const saveAsignaModalFiltro = async () => {
    const data = {
      id: idNegocio,
      idPac: idPac,
      tipoAsigna: modalidad,
      idUSer: idUser,
    };

    await saveAsignaModalidadUso(data).then((res) => {
      if (res.data > 0) {
        setEstatus("Asignado");
        successNotification(
          "Asignación de modalidad",
          "Se han registrado los datos de forma correcta.",
        );
        setEstatus("Asignado");
      }
    });
  };

  const confirm = () =>
    new Promise(async (resolve) => {
      const data = {
        id: idNegocio,
        idPac: idPac,
        idEntrada: idEntrada,
        idUser: idUser,
        claveSerie: "",
      };
      await saveAsignaFiltro(data).then(async (res) => {
        if (res.data > 0) {
          successNotification(
            "Asignación",
            "Se asgino el filtro de forma correcta.",
          );
          setTimeout(() => {
            window.location.reload();
          }, 600);
        } else {
          resolve(null);
          errorNotificaction(
            "Error_Asignacion",
            "Ocurrio un error al asignar.",
          );
        }
      });
    });

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadPacientes();
    }
  }, []);

  return (
    <LayoutHome
      titleItems={[
        {
          title: (
            <a href="/#/App/Home" style={{ textDecoration: "none" }}>
              Menú
            </a>
          ),
        },
        { title: "Asignación de Filtro" },
      ]}
      selectedKey={"4"}
    >
      {contextHolder}
      <div className="row mb-3">
        <div className="col-lg-7 col-md-7 col-sm-7">
          <Card title="Selecciona la modalidad de uso en cada sesión">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6">
                <Text size={"md"}>Paciente</Text>
                <SelectPicker
                  data={listPacientes}
                  value={idPac}
                  onChange={(e) => getAsignaModalidad(e)}
                  block
                  placeholder="-- Selecciona --"
                />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-4">
                <Text size={"md"}>Modalidad de uso (Filtro)</Text>
                <SelectPicker
                  data={listModalidad}
                  searchable={false}
                  block
                  value={modalidad}
                  onChange={(e) => setModalidad(e)}
                  placeholder="-- Selecciona --"
                />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <br></br>
                <Button
                  disabled={idPac > 0 && modalidad !== "" ? false : true}
                  onClick={saveAsignaModalFiltro}
                  icon={<FaSave></FaSave>}
                  type="primary"
                  block
                >
                  Guardar
                </Button>
              </div>
            </div>
          </Card>
        </div>
        <div className="col-lg-5 col-md-5 col-sm-5">
          <Card title="Asignación de Filtro Dializador">
            <div className="row">
              <div className="col-lg-9 col-md-9 col-sm-9">
                <Text>Filtro</Text>
                <SelectPicker
                  data={listInvent}
                  block
                  value={idEntrada}
                  onChange={(e) => setIdEntrada(e)}
                  placeholder="-- SELECCIONA --"
                  disabled={estatus === "Asignado" ? false : true}
                />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <br></br>
                <Popconfirm
                  title="Asignar filtro"
                  description="¿Esta seguro de asignar eset filtro al paciente?"
                  okText="Si"
                  onConfirm={confirm}
                  cancelText="No"
                >
                  <Button danger disabled={idEntrada === null ? true : false}>
                    Asignar
                  </Button>
                </Popconfirm>
              </div>
            </div>
          </Card>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Card title="Lista de pacientes con filtro">
            <Table
              size="small"
              bordered
              rowKey={(record) => record.ultimaFecha}
              columns={columns}
              dataSource={dataPacientesFiltro}
              pagination={{ pageSize: 5 }}
            />
          </Card>
        </div>
      </div>
    </LayoutHome>
  );
};
